import unescapedText from 'I18n/utils/unescapedText';
import { useCallback } from 'react';
import { RequirablePropertyInputEnum } from '../../input/PropertyInputGetters';
import { useAdditionalPropertyValues } from '../hooks/useAdditionalPropertyValues';
import { useProperty } from '../hooks/useProperty';
import { getBillingPeriod, isWeeklyOrBiweeklyBillingFrequency, MONTHS, parsePeriodValue, WEEKS } from '../utils/period';
import { usePropertyValue } from '../hooks/usePropertyValue';
import { jsx as _jsx } from "react/jsx-runtime";
function areBillingFrequencyTypesSame(billingFrequencyA, billingFrequencyB) {
  // This is the quickest way to check if two billing frequencies are the same.
  // Billing frequency types can be either weekly/biweekly type or the rest which we consider monthly types
  return isWeeklyOrBiweeklyBillingFrequency(billingFrequencyA) && isWeeklyOrBiweeklyBillingFrequency(billingFrequencyB) || !isWeeklyOrBiweeklyBillingFrequency(billingFrequencyA) && !isWeeklyOrBiweeklyBillingFrequency(billingFrequencyB);
}
const BillingFrequencyPropertyInputEnumShim = props => {
  var _parsePeriodValue, _parsePeriodValue2;
  const {
    onChange,
    onChangeMultiple
  } = props;
  const property = useProperty();
  const recurringbillingfrequencyValue = usePropertyValue();
  const placeholder = unescapedText('customerDataProperties.PropertyInputEnumShim.billingFrequencyPlaceholder');
  const emptyOptionLabel = unescapedText('customerDataProperties.PropertyInputEnumShim.billingFrequencyPlaceholder');
  const {
    data: additionalValues
  } = useAdditionalPropertyValues({
    recurringBillingPeriod: 'hs_recurring_billing_period'
  });
  const recurringBillingPeriod = additionalValues === null || additionalValues === void 0 ? void 0 : additionalValues.recurringBillingPeriod;
  const billingPeriodUnit = (_parsePeriodValue = parsePeriodValue(recurringBillingPeriod)) === null || _parsePeriodValue === void 0 ? void 0 : _parsePeriodValue.unit;
  const periodValue = (_parsePeriodValue2 = parsePeriodValue(recurringBillingPeriod)) === null || _parsePeriodValue2 === void 0 ? void 0 : _parsePeriodValue2.periodValue;

  // We override the onChange handler to conditionally update the hs_recurring_billing_period property
  // in addition to the recurringbillingfrequency property
  const onChangeHandler = useCallback(event => {
    const {
      target: {
        value: newBillingFrequency
      }
    } = event;
    const newBillingFrequencyUnit = isWeeklyOrBiweeklyBillingFrequency(newBillingFrequency) ? WEEKS : MONTHS;
    if (areBillingFrequencyTypesSame(newBillingFrequency, recurringbillingfrequencyValue) && billingPeriodUnit === newBillingFrequencyUnit) {
      // No need to update hs_recurring_billing_period if types and units match
      onChange(event);
    } else {
      // Update hs_recurring_billing_period if the new billing frequency type or unit differs
      onChangeMultiple({
        hs_recurring_billing_period: getBillingPeriod(newBillingFrequency, periodValue),
        [property.name]: newBillingFrequency
      });
    }
  }, [onChange, onChangeMultiple, property.name, recurringbillingfrequencyValue, billingPeriodUnit, periodValue]);
  return /*#__PURE__*/_jsx(RequirablePropertyInputEnum, Object.assign({}, props, {
    placeholder: placeholder,
    emptyOptionLabel: emptyOptionLabel,
    clearable: false,
    onChange: onChangeHandler
  }));
};
export default BillingFrequencyPropertyInputEnumShim;